// @ts-nocheck
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product: ProductContextModel | CartLineModel;
    overridedStyles?: ProductFuturePriceStyles;
    extendedStyles?: ProductFuturePriceStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    canSeePrices: getSettingsCollection(state).productSettings.canSeePrices,
    currentLanguage: state.context.session.language,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ProductFuturePriceStyles {
    wrapper?: InjectableCss;
    priceLabelText?: TypographyPresentationProps;
    priceLabelTextFuturePrice?: TypographyPresentationProps;
}

export const productFuturePriceStyles: ProductFuturePriceStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            word-break: break-word;
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    priceLabelTextFuturePrice: {
        size: 14,
        weight: "normal",
        css: css`
            color: ${getColor("danger.main")};
        `,
    },
    priceLabelText: {
        css: css`
            color: ${getColor("danger.main")};
        `,
    },
};

const SectionWrapper = getStyledWrapper("section");

const ProductPrice = ({ product: pricingData, canSeePrices, currentLanguage, overridedStyles }: Props) => {
    const pricing = "product" in pricingData ? pricingData.productInfo.pricing : pricingData.pricing;
    const price = pricing?.additionalResults?.futurePrice;
    const futureDate = pricing?.additionalResults?.futureDate || "";
    const date = new Date(futureDate);
    const expringDate = Date.parse(futureDate);
    const today = Date.parse(new Date().toDateString());

    const styles = useMergeProps(productFuturePriceStyles, overridedStyles);

    if (!canSeePrices || !price || today > expringDate) {
        return null;
    }

    return (
        <SectionWrapper {...styles.wrapper}>
            <Typography {...styles.priceLabelTextFuturePrice}>{`${translate("Future Price")}`}</Typography>
            <Typography {...styles.priceLabelText}>
                {`${price} ${translate("effective")} ${date?.toLocaleDateString(currentLanguage?.languageCode, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })}`}
            </Typography>
        </SectionWrapper>
    );
};

export default connect(mapStateToProps)(ProductPrice);
